
/** 比武招亲类 */
export namespace MatchMiaiKind {

    /** 通用数值 */  
    export enum GeneralValue {
        /** 丘比特之箭id */
        CUPID_ARROW_ID = '6',
        /** 彩礼倒计时 */
        BRIDE_PRICE_DOWNTIME = 8,
    }

    /** 特殊装备类型 */
    export enum SpecialEquipType {
        /** 丘比特之箭 */
        CUPID_ARROW = 'cupid_arrow',
    }   

}